import { FinancialStatementHttp } from "../services/FinancialStatementHttp";
import { FinancialStatementRepository } from "../repositories/FinancialStatementRepository";
import { APIResponse } from "../models/APIResponse";
import { FinancialStatementView } from "../dto/FinancialStatement";

export class SaveFinancialStatement {
  constructor(private readonly repo: FinancialStatementRepository) {}

  execute(dto: Omit<FinancialStatementView, "totals">): Promise<APIResponse<void>> {
    return this.repo.save(dto);
  }
}
export const saveFinancial = (repo: FinancialStatementHttp) =>
  new SaveFinancialStatement(repo);
